import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/arrow-bottom.png'


const _withScopeId = n => (_pushScopeId("data-v-7e1aca4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "program-participation-detail" }
const _hoisted_2 = { class: "header d-flex align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "group" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "detail-table hidden-xs-only" }
const _hoisted_8 = { class: "item table-header" }
const _hoisted_9 = { class: "item-content" }
const _hoisted_10 = { class: "td" }
const _hoisted_11 = { class: "td" }
const _hoisted_12 = { class: "td" }
const _hoisted_13 = {
  key: 0,
  class: "td"
}
const _hoisted_14 = {
  key: 1,
  class: "td"
}
const _hoisted_15 = { class: "td" }
const _hoisted_16 = { class: "td" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["data-bs-target"]
const _hoisted_19 = ["data-bs-target"]
const _hoisted_20 = ["data-bs-target"]
const _hoisted_21 = ["data-bs-target"]
const _hoisted_22 = ["data-bs-target"]
const _hoisted_23 = ["data-bs-target"]
const _hoisted_24 = ["data-bs-target"]
const _hoisted_25 = {
  key: 0,
  class: "void-tips"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "arrow"
  })
], -1))
const _hoisted_27 = ["id"]
const _hoisted_28 = { class: "progress-box" }
const _hoisted_29 = { class: "mobile-detail" }
const _hoisted_30 = { class: "item-title" }
const _hoisted_31 = { class: "item-content" }
const _hoisted_32 = { class: "label" }
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "item-content" }
const _hoisted_35 = { class: "label" }
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "item-content" }
const _hoisted_38 = { class: "label" }
const _hoisted_39 = { class: "value" }
const _hoisted_40 = { class: "item-content" }
const _hoisted_41 = { class: "label" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "item-content" }
const _hoisted_44 = { class: "label" }
const _hoisted_45 = { class: "value" }
const _hoisted_46 = {
  key: 0,
  class: "void-tips"
}
const _hoisted_47 = { class: "collapse-wrapper" }
const _hoisted_48 = ["data-bs-target", "onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow"
}, null, -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = ["id"]
const _hoisted_52 = { class: "progress-box" }

import { computed, reactive } from 'vue';
  import _ from 'lodash';
  import ShipmentProgress from './shipment-progress.vue';
  import { ProgramDetail } from './index';
  import { useI18n } from 'vue-i18n';
  import { confirm, request, alert } from '@/utils';
  import { SHIPMENT_STATE_MAP } from '@/constants';
  import type { UserRequestProgramShipment } from '@/types/user-request';

  interface IProps {
    detail: ProgramDetail,
    list: UserRequestProgramShipment[]
  }
  interface IEmits {
    (event: 'reload'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    detail: null,
    list: null
  },
  emits: ["reload"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'reload'): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    detail: ProgramDetail,
    list: UserRequestProgramShipment[]
  }

  const { t, locale } = useI18n();

  
  
  const stateMap = SHIPMENT_STATE_MAP;
  const collapse = reactive<{[propName: string]: boolean}>({});
  const banner = computed(() => {
    return _.get(props.detail, 'target.image.url');
  });

  const getCollapseId = (id: number) => {
    return `shipment-progress-${id}`;
  };

  const handleTriggerCollapse = (id: number) => {
    collapse[id] = !Boolean(collapse[id]);
  };

  const handleShipmentOperation = async (type: string, id: number) => {
    await confirm(type === 'cancel' ? t('Confirm cancellation?') : t('Confirm request?'));
    await request.post(`program_shipments/${id}/${type === 'cancel' ? 'cancel' : 'request_again'}`);
    alert({ title: t('Success'), content: t('Operation success'), });
    emits('reload');
  };

return (_ctx: any,_cache: any) => {
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(banner),
        class: "banner"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.detail.target.name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('Collection History')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('no')), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('Tracking number')), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('Date created')), 1),
            (_unref(locale) === 'ko')
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(t)('Date received')), 1))
              : _createCommentVNode("", true),
            (_unref(locale) === 'ja')
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(t)('Points earned')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('weight')), 1),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('Shippment history')), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass(["item", { active: _unref(collapse)[item.id] }])
          }, [
            _createElementVNode("div", {
              class: "item-content",
              onClick: ($event: any) => (handleTriggerCollapse(item.id))
            }, [
              _createElementVNode("div", {
                class: "td",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#${getCollapseId(item.id)}`
              }, _toDisplayString(item?.no || '/'), 9, _hoisted_18),
              _createElementVNode("div", {
                class: "td",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#${getCollapseId(item.id)}`
              }, _toDisplayString(item.tracking_number || '/'), 9, _hoisted_19),
              _createElementVNode("div", {
                class: "td",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#${getCollapseId(item.id)}`
              }, [
                _createVNode(_component_AppTimeFormat, {
                  time: item.created_at,
                  format: "YYYY-MM-DD"
                }, null, 8, ["time"])
              ], 8, _hoisted_20),
              (_unref(locale) === 'ko')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "td",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#${getCollapseId(item.id)}`
                  }, [
                    _createVNode(_component_AppTimeFormat, {
                      time: item.received_at,
                      format: "YYYY-MM-DD"
                    }, null, 8, ["time"])
                  ], 8, _hoisted_21))
                : _createCommentVNode("", true),
              (_unref(locale) === 'ja')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "td",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#${getCollapseId(item.id)}`
                  }, _toDisplayString(item.points_earned || '/'), 9, _hoisted_22))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "td",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#${getCollapseId(item.id)}`
              }, _toDisplayString(item.collected_item.weight), 9, _hoisted_23),
              _createElementVNode("div", {
                class: "td",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#${getCollapseId(item.id)}`
              }, [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_unref(stateMap)[item.state]) + " ", 1),
                  (item.state === 'void' && item.void_reason)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(item.void_reason), 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_26
              ], 8, _hoisted_24)
            ], 8, _hoisted_17),
            _createElementVNode("div", {
              id: getCollapseId(item.id),
              class: "collapse"
            }, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(ShipmentProgress, {
                  state: item.state,
                  unmatched: item.unmatched,
                  "show-cancel-btn": item.show_cancel_btn,
                  "show-request-again-btn": item.show_request_again_btn,
                  onCancel: ($event: any) => (handleShipmentOperation('cancel', item.id)),
                  onRequest: ($event: any) => (handleShipmentOperation('request', item.id))
                }, null, 8, ["state", "unmatched", "show-cancel-btn", "show-request-again-btn", "onCancel", "onRequest"])
              ])
            ], 8, _hoisted_27)
          ], 2))
        }), 128)),
        (!__props.list.length)
          ? (_openBlock(), _createBlock(_component_AppEmptyView, {
              key: 0,
              text: _unref(t)('No collection history record')
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_29, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "item"
          }, [
            _createElementVNode("div", _hoisted_30, _toDisplayString(item.tracking_number), 1),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('Date created')), 1),
              _createElementVNode("span", _hoisted_33, [
                _createVNode(_component_AppTimeFormat, {
                  time: item.created_at,
                  format: "YYYY-MM-DD"
                }, null, 8, ["time"])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(t)('Date received')), 1),
              _createElementVNode("span", _hoisted_36, [
                _createVNode(_component_AppTimeFormat, {
                  time: item.received_at,
                  format: "YYYY-MM-DD"
                }, null, 8, ["time"])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('Points earned')), 1),
              _createElementVNode("span", _hoisted_39, _toDisplayString(item.points_earned), 1)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(t)('weight')), 1),
              _createElementVNode("span", _hoisted_42, _toDisplayString(item.collected_item.weight), 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(t)('Shippment history')), 1),
              _createElementVNode("div", _hoisted_45, [
                _createTextVNode(_toDisplayString(_unref(stateMap)[item.state]) + " ", 1),
                (item.state === 'void' && item.void_reason)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(item.void_reason), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", {
                class: _normalizeClass(["tirgger-box", { active: _unref(collapse)[item.id] }]),
                "data-bs-toggle": "collapse",
                "data-bs-target": `#${getCollapseId(item.id)}`,
                "aria-expanded": "false",
                onClick: ($event: any) => (handleTriggerCollapse(item.id))
              }, _hoisted_50, 10, _hoisted_48),
              _createElementVNode("div", {
                id: getCollapseId(item.id),
                class: "collapse"
              }, [
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(ShipmentProgress, {
                    state: item.state,
                    "show-cancel-btn": item.show_cancel_btn,
                    "show-request-again-btn": item.show_request_again_btn,
                    onCancel: ($event: any) => (handleShipmentOperation('cancel', item.id)),
                    onRequest: ($event: any) => (handleShipmentOperation('request', item.id))
                  }, null, 8, ["state", "show-cancel-btn", "show-request-again-btn", "onCancel", "onRequest"])
                ])
              ], 8, _hoisted_51)
            ])
          ]))
        }), 128)),
        (!__props.list.length)
          ? (_openBlock(), _createBlock(_component_AppEmptyView, {
              key: 0,
              text: _unref(t)('No collection history record')
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})